import { calculatePosition } from './calculate-position';
import { findUpUntil } from '../../../../core/utils/src/dom';
var PositioningController = /** @class */ (function () {
    function PositioningController(component) {
        var _this = this;
        this.component = component;
        this.updatePosition = function () { };
        this.recalculatePosition = function () {
            if (!_this.component.isOpen()) {
                return;
            }
            var trigger = _this.component.getNode().querySelector('.awsui-popover__trigger');
            var popover = _this.component.getNode().querySelector('.awsui-popover__body');
            var dismiss = _this.component.getNode().querySelector('.awsui-popover__dismiss');
            var containingBlock = supportsContainingBlockPositioning() ? getContainingBlock(popover) : null;
            // Reset previous popover placement (to give it room to grow)
            popover.style.top = '0';
            popover.style.left = '0';
            popover.style.width = 'auto';
            popover.style.height = 'auto';
            // HACK: maximize width for column layouts
            if (popover.querySelector('awsui-column-layout')) {
                popover.style.width = '100%';
            }
            var dismissDelta = 0;
            if (dismiss) {
                var dismissWidth = dismiss.getBoundingClientRect().width || 0;
                // HACK: hide dismiss button to compute popover dimensions without wrappings due to it
                dismiss.style.display = 'none';
                var header = popover.querySelector('.awsui-popover__header');
                var content = popover.querySelector('.awsui-popover__content');
                var headerWidth = header
                    ? header.children.length > 0
                        ? header.children[0].getBoundingClientRect().width
                        : header.getBoundingClientRect().width
                    : 0;
                var contentWidth = header && content
                    ? content.children.length > 0
                        ? content.children[0].getBoundingClientRect().width
                        : content.getBoundingClientRect().width
                    : 0;
                dismissDelta = Math.max(dismissWidth - Math.max(contentWidth - headerWidth, 0), 0);
            }
            // Get rects representing key elements
            var triggerRect = trigger.getBoundingClientRect();
            var viewportRect = getViewportRect();
            var containingBlockRect = containingBlock ? containingBlock.getBoundingClientRect() : viewportRect;
            // Round up dimensions (IE11 doesn't handle subpixels too accurately)
            var popoverRect = popover.getBoundingClientRect();
            var popoverRectCeil = {
                top: popoverRect.top,
                left: popoverRect.left,
                width: Math.ceil(popoverRect.width + dismissDelta),
                height: Math.ceil(popoverRect.height)
            };
            // Calculate the arrow direction and viewport-relative position of the popover.
            var _a = calculatePosition(_this.component.getPreferredPosition(), triggerRect, popoverRectCeil, containingBlock ? containingBlockRect : document.documentElement.getBoundingClientRect(), viewportRect), actualPosition = _a.actualPosition, boundingOffset = _a.boundingOffset;
            // Get the position of the popover relative to the offset parent.
            var popoverOffset = toRelativePosition(boundingOffset, containingBlockRect);
            // Set the popover's arrow direction.
            _this.component.setActualPosition(actualPosition);
            // Position the popover
            popover.style.width = boundingOffset.width + "px";
            popover.style.top = popoverOffset.top + "px";
            popover.style.left = popoverOffset.left + "px";
            // Cache the distance between the trigger and the popover (which stays the same as you scroll),
            // and use that to recalculate the new popover position.
            var triggerRelativeOffset = toRelativePosition(popoverOffset, toRelativePosition(triggerRect, containingBlockRect));
            // redisplay dismiss
            if (dismiss) {
                dismiss.style.display = 'inline';
            }
            _this.updatePosition = function () {
                var newTriggerOffset = toRelativePosition(trigger.getBoundingClientRect(), containingBlock ? containingBlock.getBoundingClientRect() : viewportRect);
                popover.style.top = newTriggerOffset.top + triggerRelativeOffset.top + "px";
                popover.style.left = newTriggerOffset.left + triggerRelativeOffset.left + "px";
            };
        };
        this.onScroll = function () {
            if (_this.component.isOpen()) {
                if (_this.animationFrame) {
                    cancelAnimationFrame(_this.animationFrame);
                }
                _this.animationFrame = requestAnimationFrame(_this.updatePosition);
            }
        };
    }
    PositioningController.prototype.addEventListeners = function () {
        window.addEventListener('resize', this.recalculatePosition);
        document.addEventListener('scroll', this.onScroll, true);
    };
    PositioningController.prototype.removeEventListeners = function () {
        window.removeEventListener('resize', this.recalculatePosition);
        document.removeEventListener('scroll', this.onScroll, true);
    };
    return PositioningController;
}());
export default PositioningController;
/**
 * Returns an element that is used to position the given element.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
 */
function getContainingBlock(startElement) {
    return findUpUntil(startElement.parentElement, function (element) {
        var style = getComputedStyle(element);
        return (style.transform && style.transform !== 'none') || (style.perspective && style.perspective !== 'none');
    });
}
var _supportsContainingBlockPositioning = undefined;
/**
 * Returns whether `position: fixed` can be relative to transformed parents or whether it's always relative to
 * the viewport. Returns `true` on all browsers except IE.
 */
function supportsContainingBlockPositioning() {
    if (_supportsContainingBlockPositioning !== undefined) {
        return _supportsContainingBlockPositioning;
    }
    var parent = document.createElement('div');
    parent.style.transform = 'translateY(5px)';
    document.body.appendChild(parent);
    var child = document.createElement('div');
    child.style.position = 'fixed';
    child.style.top = '0';
    parent.appendChild(child);
    _supportsContainingBlockPositioning = parent.getBoundingClientRect().top === child.getBoundingClientRect().top;
    document.body.removeChild(parent);
    return _supportsContainingBlockPositioning;
}
/**
 * Get a BoundingOffset that represents the visible viewport.
 */
function getViewportRect() {
    return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
    };
}
/**
 * Convert a viewport-relative offset to an element-relative offset.
 */
function toRelativePosition(element, parent) {
    return {
        top: element.top - parent.top,
        left: element.left - parent.left
    };
}
//# sourceMappingURL=positioning-controller.js.map